import React from "react";
import styled, { css, FlattenSimpleInterpolation } from "styled-components";
import { type BodyTextProps } from "../TextProps";

export const Button2Styles = (): FlattenSimpleInterpolation => {
  return css`
    font-family: var(--font-helvetica);
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: 0.0175rem;
    text-transform: initial;
    text-align: center;
    margin: 0;
    position: relative;
  `;
};
const StyledButtonText2 = styled.span`
  ${Button2Styles}
`;

export const ButtonText2: React.FC<BodyTextProps> = ({
  children,
  ...props
}) => {
  return (
    <StyledButtonText2 {...props} data-component={"button1"}>
      {children}
    </StyledButtonText2>
  );
};

export default ButtonText2;
